import styled from 'styled-components';

export const ContentWrapper = styled.div`
  width: 100%;
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  position: relative;
  @media (prefers-color-scheme: dark) {
    color: #cecece;
  }
  [dir='rtl'] & {
    text-align: right;
  }
`;

export const TextWrapper = styled.span`
  white-space: pre-line;
  word-break: break-word;
  color: #5e5e5e;
  @media (prefers-color-scheme: dark) {
    color: #cecece;
  }
`;

export const ButtonWrapper = styled.span`
  display: inline-flex;
  position: relative;
  &::before {
    content: '';
    width: 70px;
    height: 100%;
    right: 100%;
    position: absolute;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 50%,
      #fff 100%
    );
    @media (prefers-color-scheme: dark) {
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.8) 50%,
        #000 68.47%
      );
    }
  }
  [dir='rtl'] &::before {
    right: auto;
    left: 100%;
    transform: scaleX(-1);
  }
`;

export const MoreButton = styled.span`
  border: none;
  outline: none;
  background: none;
  color: #007aff;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-inline-start: 10px;
`;
